module.exports = __webpack_public_path__ + "static/media/Code Reusability.f75d7277.jpg";